import { render, staticRenderFns } from "./ConsoleIconBtn.vue?vue&type=template&id=4a678491&scoped=true"
import script from "./ConsoleIconBtn.vue?vue&type=script&lang=js"
export * from "./ConsoleIconBtn.vue?vue&type=script&lang=js"
import style0 from "./ConsoleIconBtn.vue?vue&type=style&index=0&id=4a678491&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a678491",
  null
  
)

export default component.exports